import React from "react";
// core components
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";

const initState = {
    genericList: null,
    reloadList: false,
    selectList: null,
    data: null,
    successMessage: null,
    listError: null,
    error: null,
    loading: null,
}

const catalogoTipoObrasReducer = (state = initState, action) => {
    
    switch (action.type) {
        case "CATALOGO_TIPO_OBRAS_LIST":
            return {
                ...state,
                genericList: action.payload.data,
                reloadList: false,
                loading: null,
                listError: null,
            }
        case "CATALOGO_TIPO_OBRAS_LIST_SELECT":
            return {
                ...state,
                selectList: action.payload.data,
                error: null,
            }       
        case "CATALOGO_TIPO_OBRAS_GET":
            return {
                ...state,
                data: action.payload.data,
                loading: null,
            }
        case "CATALOGO_TIPO_OBRAS_GUARDADO":
            return {
                ...state,
                successMessage: action.payload.mensaje,
                reloadList: true,
                loading: null,
            }                
        case "CATALOGO_TIPO_OBRAS_STATUS_ACTUALIZADO":
            return {
                ...state,
                reloadList: true,
                loading: null,
            }             
        case "CATALOGO_TIPO_OBRAS_ERROR":
            return {
                ...state,
                error: action.payload.error,   
                loading: null,                     
            }
        case "CATALOGO_TIPO_OBRAS_LIST_ERROR":
            return {
                ...state,
                listError: action.payload.error,   
                loading: null,                     
            }
        case "CATALOGO_TIPO_OBRAS_LIMPIAR_MENSAJES": {
            return {
                ...state,
                successMessage: null,
                error: null,
                listError: null,
            }
        }            
        case "CATALOGO_TIPO_OBRAS_LOADING": {
            return {
                ...state,
                loading: (<CustomLinearProgress color="info" />),
            }
        }                        
        default:
            return state;
    }
}

export default catalogoTipoObrasReducer;